import {Component, Input} from '@angular/core';
import {TranslocoService} from "@jsverse/transloco";
import {Observable, startWith} from "rxjs";
import {filter, map} from "rxjs/operators";
import {ITableColumn} from "../../../../../../shared/shared/table/table-column";

export interface IImportedSummaryData {
    id: number,
    filename: string
}

export interface IUnimportedSummaryData {
    id: number,
    filename: string;
    reason: string
}

@Component({
    selector: 'app-import-summary-step',
    templateUrl: './import-summary-step.component.html',
    styleUrls: ['./import-summary-step.component.scss']
})

export class ImportSummaryStepComponent {
    @Input({required:true}) imported: IImportedSummaryData[] = [];
    @Input({required:true}) unimported: IUnimportedSummaryData [] = [];

    constructor(private _transloco: TranslocoService) {
    }

    importedColumns$: Observable<ITableColumn[]> = this._transloco.events$
            .pipe(
                startWith({
                    type: 'translationLoadSuccess'
                }),
                filter(e => e.type === 'translationLoadSuccess' || e.type ==='langChanged'),
                map(() => {
                    return [
                        {
                            title: this._transloco.translate('File name table column (import summary step) - File name'),
                            field: 'filename'
                        }
                    ]
                }),
            );

    unimportedColumns$: Observable<ITableColumn[]> = this._transloco.events$
        .pipe(
            startWith({
                type: 'translationLoadSuccess'
            }),
            filter(e => e.type === 'translationLoadSuccess' || e.type ==='langChanged'),
            map(() => {
                return[
                    {
                        title: this._transloco.translate('File name table column (import summary step) - File name'),
                        field: 'filename'
                    },
                    {
                        title:  this._transloco.translate('Reason table column (import summary step) - Reason'),
                        field: 'reason'
                    }
                ]
            }),
        )

}
